import {buttonVariants, Card} from '@ezcater/tapas';
import useTranslation from 'next-translate/useTranslation';
import {twJoin} from 'tailwind-merge';

import {EzcaterLogo} from '@/components/ui';
import useRAFImprovements from '@/hooks/useRAFImprovements';
import useTracking from '@/hooks/useTracking';

const AppDownloadCtaMobile: React.FC = () => {
  const {t} = useTranslation('common');
  const {trackClick} = useTracking();
  const {showRAFImprovements} = useRAFImprovements();

  return (
    <Card
      className={twJoin(
        'flex flex-col gap-4 p-4',
        showRAFImprovements ? 'border-0 bg-peppercorn-50' : 'mb-5',
      )}
    >
      <div className="flex items-center gap-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-md bg-green-700 p-2 text-white">
          <EzcaterLogo variant="symbol" width={32} height={32} fillClassName="fill-green-300" />
        </div>

        <div className="flex flex-col gap-1 tablet:items-start">
          <h4 className="text-left font-bold">{t('components.AppDownloadCta.titleMobile')}</h4>

          <p className="text-left text-xs">
            {t('components.AppDownloadCta.descriptionMobile1')} &mdash;{' '}
            {t('components.AppDownloadCta.descriptionMobile2')}
          </p>
        </div>
      </div>
      <a
        className={buttonVariants({size: 'medium', variant: 'primary'})}
        href="https://ezcater.onelink.me/T4QA/2im2xgzr"
        onClick={() => trackClick('footer-app-download-mobile')}
        rel="noopener noreferrer"
        target="_blank"
      >
        {t('components.AppDownloadCta.openApp')}
      </a>
    </Card>
  );
};

export default AppDownloadCtaMobile;
